module.exports = __webpack_public_path__ + "img/four1Blue.c8252aac.jpg";